module.exports = __webpack_public_path__ + "img/doctor_default_avatar.6ffc916b.png";